export default {
  finalize() {
    // Variation carousel
    $(".flex-control-nav li img").on("mouseup", function () {
      let vari = $(this).data("pa-vari");
      if (vari) {
        $("#pa_vari").val(vari);
        $(".variations select").trigger("change.wc-variation-form");
      }
    });

    // Fires whenever variation selects are changed
    $(".variations_form").on("woocommerce_variation_select_change", function () {
      var selectIsEmpty = false;
      $('.variations_form select').each(function () {
        if (!$(this).val()) {
          selectIsEmpty = true;
        }
      });
      $('.single_add_to_cart_button').prop('disabled', selectIsEmpty);
    });

    // Custom add to cart ajax call
    $(document).on('click', '.single_add_to_cart_button', function (e) {
      e.preventDefault();

      var $thisbutton = $(this),
        $form = $thisbutton.closest('form.cart'),
        id = $thisbutton.val(),
        product_qty = $form.find('input[name=quantity]').val() || 1,
        product_id = $form.find('input[name=product_id]').val() || id,
        variation_id = $form.find('input[name=variation_id]').val() || 0;

      var data = {
        action: 'woocommerce_ajax_add_to_cart',
        product_id: product_id,
        product_sku: '',
        quantity: product_qty,
        variation_id: variation_id,
      };

      $(document.body).trigger('adding_to_cart', [$thisbutton, data]);

      $.ajax({
        type: 'post',
        url: wc_add_to_cart_params.ajax_url, // eslint-disable-line
        data: data,
        beforeSend: function () {
          $thisbutton.removeClass('added').addClass('loading');
          $thisbutton.attr('disabled', 'disabled');
          $thisbutton.siblings('.added_to_cart').remove();
        },
        complete: function () {
          $thisbutton.addClass('added').removeClass('loading');
          $thisbutton.attr('disabled', false);
        },
        success: function (response) {
          if (response.error && response.product_url) {
            window.location = response.product_url;
            return;
          } else {
            $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $thisbutton]);
          }
        },
      });

      return false;
    });
  }
};



// WEBPACK FOOTER //
// ./scripts/routes/singleProduct.js